export default function capitalise(str){
    if (typeof str !== 'string' || str.length === 0) {
        return str; // Return the input unchanged if it's not a string or an empty string
      }
      
      return str.split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");;
}